import React from "react";
import { useNavigate } from "react-router-dom";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import {
  LoginLayout,
  WidthWrapper,
  LoginInnerWrapperOther,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import Button from "../../../components/Button";
import { Colors, Text } from "../../../config";
import SuccessPageContainer from "../../../components/SignUpLoginForgot/SuccessPageContainer";

const successImage = require("../../../assets/images/img_pinreset.png");
const nextIcon = require("../../../assets/images/Arrow_Right.png");

const ForgotSuccess = () => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("phone");
    navigate("/auth/login");
  };
  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <SuccessPageContainer
            header={Text.success}
            subheader={Text.yourAccountPinHasBeenSuccessfullyChanged}
            imgSrc={successImage}
            tagline={Text.pleaseLoginWithYourNewPin}
          />
          <WidthWrapper maxWidth="22.5rem">
            <Button
              label={Text.continueToLogin}
              onClick={handleBackClick}
              rightImgSrc={nextIcon}
              fontColor={Colors.white}
              fontSize="1.375rem"
              fontWeight="700"
              bgColor={Colors.brandTwo}
              topBottomPadding="0.75rem"
              labelImgGap="1rem"
            />
          </WidthWrapper>
        </LoginInnerWrapperOther>
      </LoginLayout>
    </>
  );
};

export default ForgotSuccess;
